<template>
 <component-payment-list-index />
</template>

<script>
import ComponentPaymentListIndex from "@/components/pages/payment/list";
export default {
  name: "edu-offline-payment-index",
  components: {ComponentPaymentListIndex}
}
</script>

<style scoped>

</style>
